var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarmToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E88A9",
    d: "M14.78 4.393 8 8.315 1.22 4.393c.3-.555.735-1.043 1.223-1.313L6.448.86c.855-.48 2.25-.48 3.105 0l4.005 2.22c.487.27.922.757 1.222 1.313Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E88A9",
    d: "M8 8.315V15.5c-.562 0-1.125-.12-1.552-.36l-4.005-2.22c-.908-.502-1.65-1.762-1.65-2.797V5.878c0-.48.165-1.005.427-1.485L8 8.315Z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E88A9",
    d: "M15.207 5.878v4.245c0 1.035-.742 2.295-1.65 2.797l-4.005 2.22c-.427.24-.99.36-1.552.36V8.315l6.78-3.922c.262.48.427 1.005.427 1.485Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmToken);
export default __webpack_public_path__ + "static/media/farm-token.5b401c609e0942d7d2137507fc438471.svg";
export { ForwardRef as ReactComponent };